var map = {
	"./balaji.webp": 55628,
	"./karthikeyan.webp": 13166,
	"./krishnaraja.webp": 78911,
	"./ksampathkumar.webp": 26244,
	"./manoj.webp": 33172,
	"./navaneethan.webp": 74190,
	"./pradeep.webp": 1186,
	"./prasath.webp": 7524,
	"./rampradheep.webp": 14824,
	"./raviprakash.webp": 883,
	"./sampathkumar.webp": 38879,
	"./venkatachalam.webp": 27807,
	"./vishnuvardhan.webp": 75194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16583;